export default "__VITE_ASSET__DskNaPoG__"